<div class="page pagePadding">
  <div class="row mt-4 mb-4">
    <div class="col">
      <form>
        <div class="iconAndName">
          <div>
            <img src="/static/img/Group.svg">
          </div>
          <div class="nameStyle">
            Игроки
          </div>
        </div>
        <div class="col-md-3 form-group">
          <div class="input-group">
            <div class="input-group-prepend">
              <i class="bi bi-search input-group-text search_item"></i>
            </div>
            <input
              type="text"
              name="query"
              id="query"
              class="form-control input-form-control"
              #searchInput
              placeholder="Поиск"
              [ngModel]="getChangedValue()"
              (ngModelChange) = "onChangeEmitter($event)"
            />
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
